import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'resource-activities',
  templateUrl: './resource-activities.component.html',
  styleUrls: ['./resource-activities.component.scss']
})
export class ResourceActivitiesComponent implements OnInit {

  @Input() resources;
  constructor() { }

  ngOnInit(): void {
  }

}
